// Packages
import React, { useContext } from 'react';
import get from 'lodash/get';
import { useNavigate } from 'react-router-dom';

// Relatives
import UserContext from '../../contexts/UserContext/UserContext';
import Layout from '../../layouts/Layout';
import Organisation from '../Login/steps/Organisation';

const NgoFinancialUpdate = () => {
  const { userNGOSelected, refreshNGOs } = useContext(UserContext);
  const id = get(userNGOSelected, 'id');
  const navigate = useNavigate();
  const ngoName = get(userNGOSelected, 'virtual_artist_handle', 'NGO');

  const handleSubmit = async data => {
    if (!data) {
      return;
    }

    await refreshNGOs();
    navigate('/campaigns');
  };

  const handleCancel = () => {
    navigate('/campaigns');
  };

  return (
    <Layout title={`Update ${ngoName}`} breadcrumb={['Home', `Update ${ngoName}`]}>
      <div className="ngo-update" key="ngo">
        <Organisation onSubmit={handleSubmit} onCancel={handleCancel} id={id} financialUpdate />
      </div>
    </Layout>
  );
};

NgoFinancialUpdate.defaultProps = {};

NgoFinancialUpdate.propTypes = {};

export default NgoFinancialUpdate;
